import React from "react";
import { Link } from "react-router-dom";

export default function Navbar() {
  return (
    <nav className="navbar navbar-expand-lg shadow-sm" style={{ backgroundColor: "#FF7A00" }}>
      <div className="container">
        {/* Logo + Brand */}
        <Link
          className="navbar-brand d-flex align-items-center fw-bold"
          to="/"
          style={{ color: "#FFFFFF" }} // Texto en blanco
        >
          {/* SVG Logo en blanco */}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="28"
            height="28"
            fill="#FFFFFF"
            className="bi bi-clock-history me-2"
            viewBox="0 0 16 16"
          >
            <path d="M8.515 1.019A7 7 0 1 0 15 8a.5.5 0 0 0-1 0 6 6 0 1 1-5.485-6.981z" />
            <path d="M7.5 3a.5.5 0 0 1 .5.5v4.25l3.15 1.85a.5.5 0 1 1-.5.866L7.5 8.5V3.5A.5.5 0 0 1 7.5 3z" />
          </svg>
          Turnora
        </Link>

        {/* Toggler for mobile (aunque sin links no hace mucho) */}
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* Se elimina todo el bloque de links */}
      </div>
    </nav>
  );
}
